import _ from "lodash";
import React, { Fragment } from "react";
import classNames from "classnames";
import { Tooltip } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import {
  SYNC_STATUS,
  SYNC_STATUS_CONFIG,
} from "LearningCourse/modules/LearningCourseUtils";

import classes from "./LearningCourseDiffSyncStatus.scss";

const getCompStatusConfig = ({ t }) => {
  return {
    IN_SYNC: {
      key: "IN_SYNC",
      tooltip: count => t("common:update_will_sync", { count }),
      icon: _.get(SYNC_STATUS_CONFIG, [SYNC_STATUS.IN_SYNC, "icon"]),
    },
    CANNOT_SYNC: {
      key: "CANNOT_SYNC",
      tooltip: count => t("common:cannot_be_synced", { count }),
      icon: _.get(SYNC_STATUS_CONFIG, [SYNC_STATUS.CANNOT_SYNC, "icon"]),
    },
    PENDING_SYNC: {
      key: "PENDING_SYNC",
      tooltip: count => t("course:pending_sync", { count }),
      icon: _.get(SYNC_STATUS_CONFIG, [SYNC_STATUS.PENDING_SYNC, "icon"]),
    },
  };
};

const COMP_STATUS = ["IN_SYNC", "CANNOT_SYNC", "PENDING_SYNC"];

const getTooltipText = ({ workflowSubTaskMetadata, t, statusesToShow }) => {
  const COMP_STATUS_CONFIG = getCompStatusConfig({ t });
  let text = "";

  _.forEach(statusesToShow, (statusKey, index) => {
    const { tooltip = () => {} } = COMP_STATUS_CONFIG[statusKey];
    const count = !_.isNil(_.get(workflowSubTaskMetadata, statusKey))
      ? _.get(workflowSubTaskMetadata, statusKey)
      : 0;

    if (count > 0) {
      const isLast = index === _.size(statusesToShow) - 1;
      text += tooltip(count);

      if (!isLast) {
        text += " ";
      }
    }
  });

  return text;
};

const LearningCourseDiffSyncStatusComp = props => {
  const { workflowSubTaskMetadata = {}, statusLabel } = props;

  const { t } = useI18n(["common", "course"]);

  const COMP_STATUS_CONFIG = getCompStatusConfig({ t });
  // pick only statuses that have a non-zero count
  const statusesToShow = _.filter(COMP_STATUS, statusKey => {
    const count = !_.isNil(_.get(workflowSubTaskMetadata, statusKey))
      ? _.get(workflowSubTaskMetadata, statusKey)
      : 0;
    return count > 0;
  });

  const toolTipText = getTooltipText({
    workflowSubTaskMetadata,
    t,
    statusesToShow,
  });

  if (_.isEmpty(workflowSubTaskMetadata) || _.isEmpty(statusesToShow)) {
    return statusLabel;
  }

  const statusCountTextClass = classNames(
    classes.statusTextContainer,
    "text-body-s"
  );

  return (
    <Tooltip tooltip={toolTipText} placement="right" zIndex={1000000}>
      <div className={classes.container}>
        {_.map(statusesToShow, (statusKey, index) => {
          const { icon } = COMP_STATUS_CONFIG[statusKey];
          const count = !_.isNil(_.get(workflowSubTaskMetadata, statusKey))
            ? _.get(workflowSubTaskMetadata, statusKey)
            : 0;
          const isLast = index === _.size(statusesToShow) - 1;

          return count > 0 ? (
            <Fragment key={statusKey}>
              <div className={classes.statusContainer}>
                {icon}
                <div className={statusCountTextClass}>{count}</div>
              </div>
              {!isLast ? (
                <div className={classes.separatorContainer}>
                  <div className={classes.dot} />
                </div>
              ) : null}
            </Fragment>
          ) : null;
        })}
      </div>
    </Tooltip>
  );
};

export default LearningCourseDiffSyncStatusComp;
